// Shared formatting utilities for exception reports and other components

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
  }).format(amount)
}

export const formatDiscrepancy = (amount: number): string => {
  // Show full precision up to 8 decimal places
  return amount.toFixed(8).replace(/\.?0+$/, '')
}

export const formatDate = (dateString?: string): string => {
  if (!dateString) return 'N/A'
  return new Date(dateString).toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

export const formatDateTime = (dateString?: string): string => {
  if (!dateString) return 'N/A'
  return new Date(dateString).toLocaleDateString('en-AU', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const formatNumber = (value: number, decimals: number = 2): string => {
  return value.toFixed(decimals)
}

export const formatPercentage = (value: number, decimals: number = 1): string => {
  return `${(value * 100).toFixed(decimals)}%`
}

// Customer/client name formatting for sales data
export interface CustomerData {
  customer_id?: string
  customer_first_name?: string
  customer_last_name?: string
  customer_company?: string
}

export const formatClientName = (customer: CustomerData): string => {
  const parts = []
  if (customer.customer_first_name) parts.push(customer.customer_first_name)
  if (customer.customer_last_name) parts.push(customer.customer_last_name)
  if (customer.customer_company) parts.push(`(${customer.customer_company})`)
  return parts.length > 0 ? parts.join(' ') : customer.customer_id || 'N/A'
}